import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { YoutubeAnalyticsTagRankingPayload } from '@anytag/graphql';
import { useInfluencerYoutubeTagsRankingTable } from './hooks';

type YoutubeTagsRankingTableProps = TableData<YoutubeAnalyticsTagRankingPayload>;

export const YoutubeTagsRankingTable = ({ loading, data = [] }: YoutubeTagsRankingTableProps) => {
  const { columns } = useInfluencerYoutubeTagsRankingTable();

  return <TableV2 data={data} rowHeight="40px" loading={loading} columns={columns} noTopBorderRadius hasBorder />;
};
